import {gsap} from "gsap";

export class BruteForceReelScreenDarkOverlayView extends PIXI.Container {

    private _overlay: PIXI.Sprite;

   //  private _bigwinsOverlayTint: number[] = [0x234f00, 0x514d01, 0x500301, 0x510301, 0x512a01];

    constructor() {
        super();
        this.name = "BruteForceReelDarkOverlay";
        this.init();
    }

    private init() {
        this.createOverlay();
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._overlay.name = "overlay";
        this._overlay.tint = 0x000000;
        this._overlay.alpha = 0.7;
        this._overlay.visible = false;

        this._overlay.width = 1680;
        this._overlay.height = 1680;
        this._overlay.position.set(360, 360);
        this._overlay.anchor.set(0.5, 0.5);
        this.addChild(this._overlay);
    }

    public addOverlay(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._overlay.alpha = 0;
            this._overlay.visible = true;
            this._overlay.tint = 0x000000;
        });
        tl.to(this._overlay, {duration: 0.05, alpha: 0.65});
        return tl;
    }

    public hideOverlay(): gsap.core.Timeline {
        const hideOverlayTl: gsap.core.Timeline = gsap.timeline();
        hideOverlayTl.to(this._overlay, {duration: 0.5, alpha: 0});
        hideOverlayTl.add(() => {
            this._overlay.visible = false;
        });

        return hideOverlayTl;
    }


}